export const fields = {
  comment: {
    label: "Comment",
    value: null,
    rules: "required|string",
  },

  priceExpiryReviewDate: {
    label: "Price Expiry Review Date",
    value: null,
    rules: "required|validDate|minDateValidator",
  },
};
